<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Unable to process {{ type }}</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    ngbTooltip="Close"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog">
  <p>There were issues processing your {{ type }} request.</p>
  <ng-container *ngIf="messageMap">
    <div *ngFor="let item of messageMap | keyvalue">
      <div>
        <strong>{{ item.key }}</strong>
      </div>
      <ul>
        <li *ngFor="let job of item.value">{{ job }}</li>
      </ul>
    </div>
  </ng-container>
</div>
